import {FC} from 'react'
import {useIntl} from 'react-intl'
import {toAbsoluteUrl} from '../../../_heomoney/helpers'
import {PageTitle} from '../../../_heomoney/layout/core'
import {
  MixedWidget15,
  CardsWidget7,
  CardsWidget17,
  CardsWidget20,
  EngageWidget10,
} from '../../../_heomoney/partials/widgets'

const DashboardPage: FC = () => (
  <>

    <div className='row g-5 g-xl-10 mb-5 mb-xl-10'>
      {/* begin::Col */}
      <div className='col-md-6 col-lg-6 col-xl-6 col-xxl-3 mb-md-5 mb-xl-10'>
        <CardsWidget20
          className='h-md-50 mb-5 mb-xl-10'
          description='HeoTandas Activas'
          color='#E96C14'
          img={toAbsoluteUrl('/media/patterns/vector-1.png')}
        />
        <CardsWidget7
          className='h-md-50 mb-5 mb-xl-10'
          description='Tanderos con las que participo'
          icon={false}
          stats={35}
          labelColor='dark'
          textColor='gray-300'
        />
      </div>

      <div className='col-md-6 col-lg-6 col-xl-6 col-xxl-3 mb-md-5 mb-xl-10'>
        <CardsWidget17 className='h-md-50 mb-5 mb-xl-10' />
        <div className='col-xl-12'>
          <MixedWidget15 className='card-xl-stretch mb-xl-10' backGroundColor='#CBD4F4' />
        </div>
      </div>

      <div className='col-xxl-6'>
        <EngageWidget10 className='h-md-100' />
      </div>

    </div>

    <div className='row gx-5 gx-xl-10'>

      <div className='col-xxl-6 mb-5 mb-xl-10'>
     </div>

      <div className='col-xxl-6 mb-5 mb-xl-10'>
    </div>

    </div>


    <div className='row g-5 gx-xxl-8'>
      
    </div>
  </>
)

const DashboardWrapper: FC = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.DASHBOARD'})}</PageTitle>
      <DashboardPage />
    </>
  )
}

export {DashboardWrapper}
